import { Box } from "@mui/material";
import PropTypes from "prop-types";

const getMessage = (type, customError, directMessage = null) => {
  const directMs = ["custom", "validate", "pattern", "unique"]
  if (directMs.includes(type) && directMessage) return directMessage;

  if (customError && typeof customError === "object" && customError[type]) {
    return customError[type];
  }

  switch (type) {
    case "required":
      return "This field is required.";
    case "maxLength":
      return "Maximum length exceeded.";
    case "minLength":
      return "Minimum length not met.";
    case "pattern":
      return "Invalid format.";
    case "order":
      return "Order number already exists.";
    case "name":
      return "Name already exists.";
    case "setup":
      return "FastRack setup already exists.";
    case "code":
      return "Code number already exists.";
    case "min":
      return "The number you entered is too small. Please enter a valid whole number.";
    case "max":
      return "The number you entered is too large. Please enter a valid whole number.";
    default:
      return "Invalid input.";
  }
};

const FormError = ({ errors, controlId, customError = null }) => {
  if (!errors?.[controlId]) return null;

  const errorId = `${controlId}-error`;

  return (
    <Box
      style={{ color: "red", fontSize: "12px" }}
      id={errorId}
      role="alert"
      aria-live="polite"
    >
      {getMessage(errors[controlId].type, customError, errors[controlId].message)}
    </Box>
  );
};

FormError.propTypes = {
  errors: PropTypes.object.isRequired,
  controlId: PropTypes.string.isRequired,
  customError: PropTypes.object,
};

export default FormError;
